export const GETALL_SUBMITTEDUSERS_REQUEST = "GETALL_SUBMITTEDUSERS_REQUEST";
export const GETALL_SUBMITTEDUSERS_SUCCESS = "GETALL_SUBMITTEDUSERS_SUCCESS";
export const GETALL_SUBMITTEDUSERS_FAIL = "GETALL_SUBMITTEDUSERS_FAIL";

export const COMPLETE_USER_SUBMISSION_REQUEST =
  "COMPLETE_USER_SUBMISSION_REQUEST";
export const COMPLETE_USER_SUBMISSION_SUCCESS =
  "COMPLETE_USER_SUBMISSION_SUCCESS";
export const COMPLETE_USER_SUBMISSION_FAIL = "COMPLETE_USER_SUBMISSION_FAIL";

export const GET_CERTIFICATE_PUBLIC_URL_REQUEST =
  "GET_CERTIFICATE_PUBLIC_URL_REQUEST";
export const GET_CERTIFICATE_PUBLIC_URL_SUCCESS =
  "GET_CERTIFICATE_PUBLIC_URL_SUCCESS";
export const GET_CERTIFICATE_PUBLIC_URL_FAIL =
  "GET_CERTIFICATE_PUBLIC_URL_FAIL";
